var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import classNames from 'classnames';
import omit from 'lodash/omit';

import IconClear from '../../icons/general/IconClear';
import IconSearch from '../../icons/general/IconSearch';

import makeLoadable from '../loading-indicator/makeLoadable';

import './SearchForm.scss';

var messages = defineMessages({
    clearButtonTitle: {
        'id': 'boxui.searchForm.clearButtonTitle',
        'defaultMessage': 'Clear'
    },
    searchButtonTitle: {
        'id': 'boxui.searchForm.searchButtonTitle',
        'defaultMessage': 'Search'
    },
    searchLabel: {
        'id': 'boxui.searchForm.searchLabel',
        'defaultMessage': 'Search query'
    }
});

var SearchForm = function (_React$Component) {
    _inherits(SearchForm, _React$Component);

    function SearchForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isEmpty: true
        }, _this.onClearHandler = function (event) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                shouldPreventClearEventPropogation = _this$props.shouldPreventClearEventPropogation;

            if (shouldPreventClearEventPropogation) {
                event.stopPropagation();
            }

            if (_this.searchInput) {
                _this.searchInput.value = '';
            }
            _this.setState({ isEmpty: true });

            if (onChange) {
                onChange('');
            }
        }, _this.onChangeHandler = function (_ref2) {
            var target = _ref2.target;
            var value = target.value;
            var onChange = _this.props.onChange;

            _this.setState({ isEmpty: !value || !value.trim().length });

            if (onChange) {
                onChange(value);
            }
        }, _this.onSubmitHandler = function (event) {
            var value = event.target.elements[0].value;
            var onSubmit = _this.props.onSubmit;


            if (onSubmit) {
                onSubmit(value, event);
            }
        }, _this.setInputRef = function (element) {
            _this.searchInput = element;

            if (_this.props.getSearchInput) {
                _this.props.getSearchInput(_this.searchInput);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchForm, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var value = nextProps.value;
            // update state if input is controlled and becomes empty

            if (typeof value !== 'undefined' && !value.trim()) {
                this.setState({ isEmpty: true });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                action = _props.action,
                className = _props.className,
                intl = _props.intl,
                isLoading = _props.isLoading,
                method = _props.method,
                name = _props.name,
                queryParams = _props.queryParams,
                useClearButton = _props.useClearButton,
                rest = _objectWithoutProperties(_props, ['action', 'className', 'intl', 'isLoading', 'method', 'name', 'queryParams', 'useClearButton']);

            var isEmpty = this.state.isEmpty;


            var inputProps = omit(rest, ['getSearchInput', 'onChange', 'onSubmit', 'required']);

            var formatMessage = intl.formatMessage;

            var classes = classNames(className, 'search-input-container');
            var formClassNames = classNames('search-form', {
                'is-empty': isEmpty,
                'use-clear-button': useClearButton
            });
            var hiddenInputs = Object.keys(queryParams).map(function (param, index) {
                return React.createElement('input', {
                    key: index,
                    name: param,
                    type: 'hidden',
                    value: queryParams[param]
                });
            });

            var SearchActions = function SearchActions() {
                return React.createElement(
                    'div',
                    { className: 'action-buttons' },
                    React.createElement(
                        'button',
                        {
                            className: 'action-button search-button',
                            title: formatMessage(messages.searchButtonTitle)
                        },
                        React.createElement(IconSearch, null)
                    ),
                    React.createElement(
                        'button',
                        {
                            className: 'action-button clear-button',
                            onClick: _this2.onClearHandler,
                            title: formatMessage(messages.clearButtonTitle),
                            type: 'button'
                        },
                        React.createElement(IconClear, null)
                    )
                );
            };

            var LoadableSearchActions = makeLoadable(SearchActions);

            // @NOTE(jtan)Prevent errors from React about controlled inputs
            var onChangeStub = function onChangeStub() {};

            return React.createElement(
                'div',
                { className: classes },
                React.createElement(
                    'form',
                    {
                        action: action,
                        className: formClassNames,
                        method: method,
                        onChange: this.onChangeHandler,
                        onSubmit: this.onSubmitHandler,
                        role: 'search'
                    },
                    React.createElement('input', _extends({
                        autoComplete: 'off',
                        'aria-label': formatMessage(messages.searchLabel),
                        className: 'search-input',
                        name: name,
                        ref: this.setInputRef,
                        type: 'search',
                        onChange: onChangeStub
                    }, inputProps)),
                    React.createElement(LoadableSearchActions, {
                        isLoading: isLoading,
                        loadingIndicatorProps: {
                            className: 'search-form-loading-indicator'
                        }
                    }),
                    hiddenInputs
                )
            );
        }
    }]);

    return SearchForm;
}(React.Component);

SearchForm.defaultProps = {
    action: undefined,
    method: 'get',
    name: 'search',
    queryParams: {},
    useClearButton: false
};
SearchForm.propTypes = {
    /** Form submit action */
    action: PropTypes.string,
    className: PropTypes.string,
    getSearchInput: PropTypes.func,
    intl: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,

    /** The way to send the form data, get or post */
    method: PropTypes.oneOf(['get', 'post']),

    /** Name of the text input */
    name: PropTypes.string,

    /** On change handler for the search input, debounced by 250ms */
    onChange: PropTypes.func,

    /** On submit handler for the search input */
    onSubmit: PropTypes.func,

    /** Extra query parameters in addition to the form data */
    queryParams: PropTypes.object.isRequired,

    /** Boolean to prevent propogation of search clear action */
    shouldPreventClearEventPropogation: PropTypes.bool,

    /** If the clear button is shown when input field is not empty */
    useClearButton: PropTypes.bool,

    /** The value of the input if controlled */
    value: PropTypes.string
};


export default injectIntl(SearchForm);
import PropTypes from 'prop-types';